import { render, staticRenderFns } from "./CompetitionDetail.vue?vue&type=template&id=5bba864f&scoped=true&"
import script from "./CompetitionDetail.vue?vue&type=script&lang=js&"
export * from "./CompetitionDetail.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionDetail.vue?vue&type=style&index=0&id=5bba864f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bba864f",
  null
  
)

export default component.exports